import {
  SaveLongTokenDurationSecureType,
  RemoveLongTokenDurationSecure,
} from '@/types/security';

export class Security {
  static saveLongTokenDurationSecure: SaveLongTokenDurationSecureType;
  static removeLongTokenDurationSecure: RemoveLongTokenDurationSecure;

  static init = (
    saveLongTokenDurationSecure: SaveLongTokenDurationSecureType,
    removeLongTokenDurationSecure: RemoveLongTokenDurationSecure,
  ) => {
    Security.saveLongTokenDurationSecure = saveLongTokenDurationSecure;
    Security.removeLongTokenDurationSecure = removeLongTokenDurationSecure;
  };
}
